// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__29ir3","savePackageButton":"ClientWallet_savePackageButton__1ecmR"};